import { apiClient } from './apiClient';

class ChefAPI {
  getChef(id) {
    return apiClient.request(`/chefs/${id}`, 'GET', true);
  }

  getChefs() {
    return apiClient.request(`/chefs/`, 'GET', true);
  }

  getChefServices(id, params = {}) {
    return apiClient.request(`/chefs/${id}/services`, 'POST', true, params);
  }

  getAvailableChefs(params) {
    return apiClient.request(
      `/chefs/service-availabilities`,
      'POST',
      true,
      params
    );
  }

  createChef(chef) {
    return apiClient.request(`/chefs`, 'POST', true, chef);
  }

  updateChef(chef) {
    return apiClient.request(`/chefs/${chef.id}`, 'PUT', true, chef);
  }

  deleteChef(id, hard_delete = false) {
    return apiClient.request(`/chefs/${id}`, 'DELETE', true, { hard_delete });
  }

  inactivateChef(id) {
    return apiClient.request(`/chefs/${id}/inactivate`, 'PUT', true);
  }

  restoreChef(id) {
    return apiClient.request(`/chefs/${id}/restore`, 'POST', true);
  }

  searchChefs(params = {}) {
    return apiClient.request(`/chefs/search`, 'POST', true, params);
  }

  getServiceDistricts() {
    return apiClient.request(`/service_districts`, 'GET', true);
  }

  declineService(chefId, serviceId) {
    return apiClient.request(
      `/services/${serviceId}/chefs/${chefId}/reject`,
      'PATCH',
      true
    );
  }

  acceptService(chefId, serviceId) {
    return apiClient.request(
      `/services/${serviceId}/chefs/${chefId}/accept`,
      'PATCH',
      true
    );
  }

  tokenAcceptService(token) {
    return apiClient.request(
      `/chefs/token_confirm/accept/${token}`,
      'PATCH',
      true
    );
  }

  tokenRejectService(token) {
    return apiClient.request(
      `/chefs/token_confirm/reject/${token}`,
      'PATCH',
      true
    );
  }
}
export const chefAPI = new ChefAPI();



// WEBPACK FOOTER //
// ./src/InterfaceAPI/chefAPI.js